import EDHttp from '../utils/EDHttp';

export default {
    async sendFax(data) {
        try {
            const { data: result } = await EDHttp.post("/admin/fax", data);
            return result.data;
        } catch(error) {
            throw error.response.data.message;
        }
    },
    async getFax(page, search = '') {
        try {
            const { data: result } = await EDHttp.get(`/admin/fax?page=${page}&search=${search}`);
            return result.data;
        } catch (error) {
            throw error.response.data.message;
        }
    },
    async getFaxById(id) {
        try {
            const { data: result } = await EDHttp.get(`/admin/fax/${id}`);
            return result.data;
        } catch (error) {
            throw error.response.data.message;
        }
    }
}
